const translations = {
  en: {
    translation: {
      // App
      appName: "EReMS Cameroon",
      appTagline: "Cameroon Election Monitoring Platform",
      
      // Navigation
      nav: {
        dashboard: "Dashboard",
        interactiveMap: "Interactive Map",
        pollingStations: "Polling Stations",
        submitResults: "Submit Results",
        viewResults: "View Results",
        collation: "Results Collation",
        statistics: "Statistics",
        candidates: "Candidates",
        subscription: "Subscription",
        clients: "Client Management",
        liveReporting: "Live Reporting",
        analytics: "Analytics",
        signOut: "Sign Out"
      },
      
      // Auth
      auth: {
        signIn: "Sign In",
        signUp: "Create Account",
        email: "Email",
        password: "Password",
        fullName: "Full Name",
        role: "Role",
        forgotPassword: "Forgot password?",
        noAccount: "Don't have an account?",
        hasAccount: "Already have an account?",
        register: "Register",
        login: "Login",
        enterCredentials: "Enter your credentials to access the platform"
      },
      
      // Roles
      roles: {
        owner: "App Owner",
        client: "Client",
        admin: "Administrator",
        observer: "Observer",
        reporter: "Reporter"
      },
      
      // Dashboard
      dashboard: {
        title: "Election Monitoring Dashboard",
        subtitle: "Real-time overview of Cameroon election results across all regions",
        pollingStations: "Polling Stations",
        registeredVoters: "Registered Voters",
        votesCast: "Votes Cast",
        validVotes: "Valid Votes",
        turnout: "Voter Turnout",
        pending: "Pending Verification",
        verified: "Verified Results",
        disputed: "Disputed Results",
        quickActions: "Quick Actions"
      },
      
      // Map
      map: {
        title: "Interactive Map of Cameroon",
        regions: "Regions",
        divisions: "Divisions",
        subdivisions: "Subdivisions",
        villages: "Villages",
        searchVillages: "Search villages...",
        currentLevel: "Current Level",
        legend: "Legend",
        regionalCapital: "Regional Capital",
        divisionHQ: "Division HQ",
        subdivisionHQ: "Subdivision HQ",
        downloadMap: "Download Map",
        exportPDF: "Export as PDF",
        exportPNG: "Export as PNG"
      },
      
      // Polling Stations
      pollingStations: {
        title: "Polling Stations",
        subtitle: "Find and manage polling stations",
        findNearest: "Find Nearest",
        addStation: "Add Station",
        allStations: "All Polling Stations",
        nearestStations: "Nearest Polling Stations",
        searchStations: "Search stations...",
        allRegions: "All Regions",
        stationName: "Station Name",
        capacity: "Capacity (voters)",
        contactPhone: "Contact Phone",
        useCurrentLocation: "Use Current Location",
        directions: "Directions",
        qrCode: "QR Code",
        downloadQR: "Download QR Code",
        bulkImport: "Bulk Import",
        importCSV: "Import from CSV",
        noStationsFound: "No polling stations found"
      },
      
      // Results
      results: {
        title: "Election Results",
        subtitle: "View and manage submitted results",
        addResult: "Add Result",
        submitResult: "Submit Result",
        electionType: "Election Type",
        presidential: "Presidential Election",
        parliamentary: "Parliamentary Elections",
        regional: "Regional Elections",
        council: "Council Elections",
        region: "Region",
        division: "Division",
        subdivision: "Subdivision",
        pollingStation: "Polling Station",
        registeredVoters: "Registered Voters",
        votesCast: "Votes Cast",
        validVotes: "Valid Votes",
        rejectedVotes: "Rejected Votes",
        candidateVotes: "Votes per Candidate",
        uploadPhoto: "Upload Result Sheet Photo",
        notes: "Additional Notes",
        status: {
          pending: "Pending",
          verified: "Verified",
          disputed: "Disputed",
          rejected: "Rejected",
          underReview: "Under Review"
        },
        actions: {
          verify: "Verify",
          dispute: "Dispute",
          reject: "Reject",
          requestReview: "Request Review"
        }
      },
      
      // Subscription
      subscription: {
        title: "Subscription Plans",
        subtitle: "Choose the right plan for your organization",
        currentPlan: "Current Plan",
        upgrade: "Upgrade",
        downgrade: "Downgrade",
        subscribe: "Subscribe",
        plans: {
          free: {
            name: "Free",
            price: "$0",
            features: ["View public results", "Basic map access", "Limited API calls"]
          },
          basic: {
            name: "Basic",
            price: "$200/month",
            features: ["Full map access", "Download maps", "500 API calls/day", "Email support"]
          },
          pro: {
            name: "Professional",
            price: "$500/month",
            features: ["Live reporting access", "Unlimited downloads", "5000 API calls/day", "Priority support", "Custom branding"]
          },
          enterprise: {
            name: "Enterprise",
            price: "Contact Us",
            features: ["Dedicated instance", "Unlimited API calls", "24/7 support", "Custom integrations", "White-label solution"]
          }
        }
      },
      
      // Client Portal
      client: {
        title: "Client Portal",
        subtitle: "Manage your organization's access",
        organization: "Organization",
        apiKey: "API Key",
        generateKey: "Generate New Key",
        usage: "API Usage",
        downloads: "Downloads",
        liveReporting: "Live Reporting Mode",
        embedCode: "Embed Code"
      },
      
      // Common
      common: {
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        view: "View",
        search: "Search",
        filter: "Filter",
        loading: "Loading...",
        noData: "No data available",
        error: "An error occurred",
        success: "Success",
        confirm: "Confirm",
        back: "Go Back",
        next: "Next",
        previous: "Previous",
        download: "Download",
        upload: "Upload",
        export: "Export",
        import: "Import"
      },
      
      // Offline
      offline: {
        title: "Offline Mode",
        message: "You are currently offline. Some features may be limited.",
        syncPending: "Sync pending",
        lastSync: "Last sync"
      },
      
      // Live Reporting
      liveReporting: {
        title: "Live Reporting",
        subtitle: "Real-time election results dashboard",
        coverage: "Coverage",
        pending: "Pending",
        verified: "Verified",
        disputed: "Disputed",
        regionalBreakdown: "Regional Breakdown",
        activityFeed: "Live Activity Feed",
        waitingForUpdates: "Waiting for live updates..."
      },
      
      // Analytics
      analytics: {
        title: "Comparative Analysis",
        subtitle: "Regional and division-level analytics",
        totalRegions: "Total Regions",
        totalVotes: "Total Votes",
        verified: "Verified",
        disputed: "Disputed",
        regionalComparison: "Regional Comparison",
        compareVotesAcrossRegions: "Compare votes across all regions",
        divisionBreakdown: "Division Breakdown",
        turnoutTrends: "Turnout Trends",
        submissionsByHour: "Result submissions by hour",
        noDataYet: "No data available yet",
        resultsWillAppear: "Results will appear here as they are submitted"
      },
      
      // Notifications
      notifications: {
        title: "Notifications",
        enableNotifications: "Enable Notifications",
        verificationAlerts: "Verification Alerts",
        resultUpdates: "Result Updates",
        noNotifications: "No notifications yet"
      },
      
      // Admin
      admin: {
        subscriptions: "Manage Subscriptions",
        userManagement: "User Management"
      },
      
      // User Management
      userManagement: {
        title: "User Management",
        subtitle: "Manage user accounts and permissions",
        createUser: "Create User",
        totalUsers: "Total Users",
        activeUsers: "Active Users",
        searchPlaceholder: "Search by name, email, or organization...",
        filterByRole: "Filter by role",
        filterByStatus: "Filter by status",
        allRoles: "All Roles",
        allStatus: "All Status",
        active: "Active",
        inactive: "Inactive",
        user: "User",
        organization: "Organization",
        status: "Status",
        created: "Created",
        actions: "Actions",
        createNewUser: "Create New User",
        addNewUserDesc: "Add a new user to the system with specific role and permissions",
        editUser: "Edit User",
        updateUserDesc: "Update user information and permissions",
        fullName: "Full Name",
        email: "Email",
        password: "Password",
        role: "Role",
        phone: "Phone",
        phoneOptional: "Phone (Optional)",
        organizationOptional: "Organization (Optional)",
        isActive: "Active",
        saveChanges: "Save Changes",
        deactivateConfirm: "Are you sure you want to deactivate this user?",
        noUsersFound: "No users found",
        loadingUsers: "Loading users...",
        page: "Page",
        of: "of",
        previous: "Previous",
        next: "Next"
      },
      
      // Roles & Permissions
      roles: {
        owner: "App Owner",
        client: "Client",
        admin: "Administrator",
        observer: "Observer",
        reporter: "Reporter",
        super_admin: "Super Admin",
        election_manager: "Election Manager",
        media: "Media",
        viewer: "Viewer"
      },
      
      roleDescriptions: {
        super_admin: "Full system access, can onboard and manage all users",
        election_manager: "ELECAM officials - manage elections and approve results",
        media: "Media houses - view and report on election results",
        observer: "Independent observers - view results and flag issues",
        reporter: "Field reporters - submit results",
        viewer: "Public viewers - read-only access"
      },
      
      // Interactive Map
      interactiveMap: {
        title: "Interactive Map",
        subtitle: "Explore election data by region",
        national: "National",
        nationalView: "National View",
        divisionsView: "Divisions View",
        councilsView: "Councils View",
        villagesView: "Villages View",
        backToNational: "Back to National View",
        backToDivisions: "Back to Divisions",
        backToCouncils: "Back to Councils",
        clickToDrillDown: "Click to drill down",
        clickToViewCouncils: "Click to view councils",
        clickToViewVillages: "Click to view villages",
        coverageLegend: "Coverage Legend",
        reported80Plus: "80%+ reported",
        reported50to80: "50-80% reported",
        reported20to50: "20-50% reported",
        reportedLess20: "<20% reported",
        divisions: "Divisions",
        councils: "Councils",
        villages: "Villages",
        totalDivisions: "Total Divisions",
        totalCouncils: "Total Councils",
        totalVillages: "Total Villages",
        villageView: "Village View",
        councilView: "Council View",
        divisionView: "Division View",
        municipalityView: "Municipality View",
        division: "Division",
        council: "Council",
        region: "Region",
        municipality: "Municipality",
        availableFromOSM: "From OpenStreetMap data",
        detailedBoundaries: "Detailed boundaries",
        villageBoundaries: "Village boundaries",
        coverage: "Coverage",
        complete: "complete",
        reported: "reported",
        total: "total",
        leadingCandidate: "Leading Candidate",
        leadingParty: "Leading Party",
        noDataYet: "No data yet",
        resultsWillAppear: "Results will appear once submissions are approved"
      },
      
      // Elections
      elections: {
        title: "Elections",
        subtitle: "Manage all election types",
        allTypes: "All Types",
        presidential: "Presidential",
        parliamentary: "Parliamentary",
        regional: "Regional",
        council: "Council",
        senatorial: "Senatorial",
        manage: "Manage",
        viewResults: "View Results",
        submitResults: "Submit Results",
        description: {
          presidential: "Elect the President of the Republic",
          parliamentary: "Elect Members of Parliament",
          regional: "Elect Regional Councilors",
          council: "Elect Municipal Councilors",
          senatorial: "Elect Senators"
        }
      },
      
      // Verification Portal
      verification: {
        title: "Verification Portal",
        subtitle: "Review and approve submitted results",
        pending: "Pending",
        underReview: "Under Review",
        correctionRequested: "Correction Requested",
        filterByElection: "Filter by election",
        filterByRegion: "Filter by region",
        filterByStatus: "Filter by status",
        allElections: "All elections",
        allRegions: "All regions",
        allStatuses: "All statuses",
        submittedBy: "Submitted by",
        submittedAt: "Submitted at",
        pollingStation: "Polling Station",
        electionType: "Election Type",
        region: "Region",
        actions: "Actions",
        review: "Review",
        approve: "Approve",
        reject: "Reject",
        requestCorrection: "Request Correction",
        reviewResult: "Review Result",
        resultDetails: "Result Details",
        registeredVoters: "Registered Voters",
        votesCast: "Votes Cast",
        validVotes: "Valid Votes",
        invalidVotes: "Invalid Votes",
        candidateVotes: "Candidate Votes",
        resultSheets: "Result Sheets",
        noPhotos: "No photos available",
        approvalActions: "Approval Actions",
        approveResult: "Approve Result",
        rejectResult: "Reject Result",
        requestCorrectionResult: "Request Correction",
        confirmApprove: "Confirm approval",
        confirmReject: "Confirm rejection",
        reasonForRejection: "Reason for rejection",
        reasonForCorrection: "Reason for correction request",
        cancel: "Cancel",
        confirm: "Confirm",
        noResultsPending: "No results pending verification"
      },
      
      // Election Night Dashboard
      electionNight: {
        title: "Election Night Dashboard",
        subtitle: "Real-time results for all election types",
        live: "LIVE",
        selectElection: "Select Election Type",
        nationalResults: "National Results",
        leadingCandidates: "Leading Candidates",
        topParties: "Top Parties",
        regionalBreakdown: "Regional Breakdown",
        turnoutRate: "Turnout Rate",
        resultsProgress: "Results Progress",
        divisionsCovered: "Divisions Covered",
        constituenciesCovered: "Constituencies Covered",
        councilsCovered: "Councils Covered",
        seatsCovered: "Seats Covered",
        votes: "votes",
        seats: "seats",
        councils: "councils",
        projectedWinner: "Projected Winner",
        tooEarlyToProject: "Too early to project",
        keyStats: "Key Statistics",
        totalRegistered: "Total Registered",
        totalVotesCast: "Total Votes Cast",
        validVotes: "Valid Votes",
        invalidVotes: "Invalid Votes"
      },
      
      // Buttons & Actions
      buttons: {
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        view: "View",
        create: "Create",
        update: "Update",
        submit: "Submit",
        approve: "Approve",
        reject: "Reject",
        verify: "Verify",
        download: "Download",
        upload: "Upload",
        export: "Export",
        import: "Import",
        search: "Search",
        filter: "Filter",
        reset: "Reset",
        refresh: "Refresh",
        close: "Close",
        back: "Back",
        next: "Next",
        previous: "Previous",
        confirm: "Confirm",
        yes: "Yes",
        no: "No"
      },
      
      // Messages
      messages: {
        loading: "Loading...",
        saving: "Saving...",
        saved: "Saved successfully",
        error: "An error occurred",
        success: "Operation successful",
        noData: "No data available",
        noResults: "No results found",
        confirmDelete: "Are you sure you want to delete?",
        confirmAction: "Are you sure you want to proceed?",
        unauthorized: "Unauthorized",
        permissionDenied: "Permission denied",
        sessionExpired: "Session expired. Please login again.",
        networkError: "Network error. Check your connection.",
        invalidInput: "Invalid input",
        required: "This field is required",
        uploadSuccess: "Upload successful",
        uploadFailed: "Upload failed",
        deleteSuccess: "Deleted successfully",
        deleteFailed: "Delete failed",
        updateSuccess: "Updated successfully",
        updateFailed: "Update failed",
        createSuccess: "Created successfully",
        createFailed: "Create failed"
      }
    }
  },
  fr: {
    translation: {
      // App
      appName: "EReMS Cameroon",
      appTagline: "Plateforme de Surveillance des Élections au Cameroun",
      
      // Navigation
      nav: {
        dashboard: "Tableau de Bord",
        interactiveMap: "Carte Interactive",
        pollingStations: "Bureaux de Vote",
        submitResults: "Soumettre Résultats",
        viewResults: "Voir Résultats",
        collation: "Compilation des Résultats",
        statistics: "Statistiques",
        candidates: "Candidats",
        subscription: "Abonnement",
        clients: "Gestion Clients",
        liveReporting: "Reportage en Direct",
        analytics: "Analyses",
        signOut: "Déconnexion"
      },
      
      // Auth
      auth: {
        signIn: "Connexion",
        signUp: "Créer un Compte",
        email: "Email",
        password: "Mot de passe",
        fullName: "Nom Complet",
        role: "Rôle",
        forgotPassword: "Mot de passe oublié?",
        noAccount: "Pas de compte?",
        hasAccount: "Déjà un compte?",
        register: "S'inscrire",
        login: "Se connecter",
        enterCredentials: "Entrez vos identifiants pour accéder à la plateforme"
      },
      
      // Roles
      roles: {
        owner: "Propriétaire",
        client: "Client",
        admin: "Administrateur",
        observer: "Observateur",
        reporter: "Reporter"
      },
      
      // Dashboard
      dashboard: {
        title: "Tableau de Bord de Surveillance des Élections",
        subtitle: "Aperçu en temps réel des résultats des élections au Cameroun",
        pollingStations: "Bureaux de Vote",
        registeredVoters: "Électeurs Inscrits",
        votesCast: "Votes Exprimés",
        validVotes: "Votes Valides",
        turnout: "Taux de Participation",
        pending: "En Attente de Vérification",
        verified: "Résultats Vérifiés",
        disputed: "Résultats Contestés",
        quickActions: "Actions Rapides"
      },
      
      // Map
      map: {
        title: "Carte Interactive du Cameroun",
        regions: "Régions",
        divisions: "Départements",
        subdivisions: "Arrondissements",
        villages: "Villages",
        searchVillages: "Rechercher villages...",
        currentLevel: "Niveau Actuel",
        legend: "Légende",
        regionalCapital: "Chef-lieu de Région",
        divisionHQ: "Chef-lieu de Département",
        subdivisionHQ: "Chef-lieu d'Arrondissement",
        downloadMap: "Télécharger la Carte",
        exportPDF: "Exporter en PDF",
        exportPNG: "Exporter en PNG"
      },
      
      // Polling Stations
      pollingStations: {
        title: "Bureaux de Vote",
        subtitle: "Trouver et gérer les bureaux de vote",
        findNearest: "Trouver le Plus Proche",
        addStation: "Ajouter Bureau",
        allStations: "Tous les Bureaux de Vote",
        nearestStations: "Bureaux de Vote les Plus Proches",
        searchStations: "Rechercher bureaux...",
        allRegions: "Toutes les Régions",
        stationName: "Nom du Bureau",
        capacity: "Capacité (électeurs)",
        contactPhone: "Téléphone",
        useCurrentLocation: "Utiliser Position Actuelle",
        directions: "Itinéraire",
        qrCode: "Code QR",
        downloadQR: "Télécharger Code QR",
        bulkImport: "Import en Masse",
        importCSV: "Importer depuis CSV",
        noStationsFound: "Aucun bureau de vote trouvé"
      },
      
      // Results
      results: {
        title: "Résultats des Élections",
        subtitle: "Voir et gérer les résultats soumis",
        addResult: "Ajouter Résultat",
        submitResult: "Soumettre Résultat",
        electionType: "Type d'Élection",
        presidential: "Élection Présidentielle",
        parliamentary: "Élections Législatives",
        regional: "Élections Régionales",
        council: "Élections Municipales",
        region: "Région",
        division: "Département",
        subdivision: "Arrondissement",
        pollingStation: "Bureau de Vote",
        registeredVoters: "Électeurs Inscrits",
        votesCast: "Votes Exprimés",
        validVotes: "Votes Valides",
        rejectedVotes: "Votes Rejetés",
        candidateVotes: "Votes par Candidat",
        uploadPhoto: "Télécharger Photo du PV",
        notes: "Notes Additionnelles",
        status: {
          pending: "En Attente",
          verified: "Vérifié",
          disputed: "Contesté",
          rejected: "Rejeté",
          underReview: "En Révision"
        },
        actions: {
          verify: "Vérifier",
          dispute: "Contester",
          reject: "Rejeter",
          requestReview: "Demander Révision"
        }
      },
      
      // Subscription
      subscription: {
        title: "Plans d'Abonnement",
        subtitle: "Choisissez le plan adapté à votre organisation",
        currentPlan: "Plan Actuel",
        upgrade: "Améliorer",
        downgrade: "Rétrograder",
        subscribe: "S'abonner",
        plans: {
          free: {
            name: "Gratuit",
            price: "0 $",
            features: ["Voir résultats publics", "Accès carte basique", "Appels API limités"]
          },
          basic: {
            name: "Basique",
            price: "200 $/mois",
            features: ["Accès carte complet", "Télécharger cartes", "500 appels API/jour", "Support email"]
          },
          pro: {
            name: "Professionnel",
            price: "500 $/mois",
            features: ["Accès reportage en direct", "Téléchargements illimités", "5000 appels API/jour", "Support prioritaire", "Branding personnalisé"]
          },
          enterprise: {
            name: "Entreprise",
            price: "Nous Contacter",
            features: ["Instance dédiée", "Appels API illimités", "Support 24/7", "Intégrations personnalisées", "Solution marque blanche"]
          }
        }
      },
      
      // Client Portal
      client: {
        title: "Portail Client",
        subtitle: "Gérer l'accès de votre organisation",
        organization: "Organisation",
        apiKey: "Clé API",
        generateKey: "Générer Nouvelle Clé",
        usage: "Utilisation API",
        downloads: "Téléchargements",
        liveReporting: "Mode Reportage en Direct",
        embedCode: "Code d'Intégration"
      },
      
      // Common
      common: {
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        view: "Voir",
        search: "Rechercher",
        filter: "Filtrer",
        loading: "Chargement...",
        noData: "Aucune donnée disponible",
        error: "Une erreur est survenue",
        success: "Succès",
        confirm: "Confirmer",
        back: "Retour",
        next: "Suivant",
        previous: "Précédent",
        download: "Télécharger",
        upload: "Envoyer",
        export: "Exporter",
        import: "Importer"
      },
      
      // Offline
      offline: {
        title: "Mode Hors Ligne",
        message: "Vous êtes actuellement hors ligne. Certaines fonctionnalités peuvent être limitées.",
        syncPending: "Synchronisation en attente",
        lastSync: "Dernière synchronisation"
      },
      
      // Live Reporting
      liveReporting: {
        title: "Reportage en Direct",
        subtitle: "Tableau de bord des résultats en temps réel",
        coverage: "Couverture",
        pending: "En Attente",
        verified: "Vérifiés",
        disputed: "Contestés",
        regionalBreakdown: "Répartition Régionale",
        activityFeed: "Flux d'Activité en Direct",
        waitingForUpdates: "En attente des mises à jour..."
      },
      
      // Analytics
      analytics: {
        title: "Analyse Comparative",
        subtitle: "Analyses au niveau régional et départemental",
        totalRegions: "Total Régions",
        totalVotes: "Total Votes",
        verified: "Vérifiés",
        disputed: "Contestés",
        regionalComparison: "Comparaison Régionale",
        compareVotesAcrossRegions: "Comparer les votes dans toutes les régions",
        divisionBreakdown: "Répartition par Département",
        turnoutTrends: "Tendances de Participation",
        submissionsByHour: "Soumissions de résultats par heure",
        noDataYet: "Aucune donnée disponible",
        resultsWillAppear: "Les résultats apparaîtront ici à mesure qu'ils seront soumis"
      },
      
      // Notifications
      notifications: {
        title: "Notifications",
        enableNotifications: "Activer les Notifications",
        verificationAlerts: "Alertes de Vérification",
        resultUpdates: "Mises à jour des Résultats",
        noNotifications: "Aucune notification"
      },
      
      // Admin
      admin: {
        subscriptions: "Gérer les Abonnements",
        userManagement: "Gestion des Utilisateurs"
      },
      
      // User Management
      userManagement: {
        title: "Gestion des Utilisateurs",
        subtitle: "Gérer les comptes utilisateurs et les permissions",
        createUser: "Créer Utilisateur",
        totalUsers: "Total Utilisateurs",
        activeUsers: "Utilisateurs Actifs",
        searchPlaceholder: "Rechercher par nom, email ou organisation...",
        filterByRole: "Filtrer par rôle",
        filterByStatus: "Filtrer par statut",
        allRoles: "Tous les rôles",
        allStatus: "Tous les statuts",
        active: "Actif",
        inactive: "Inactif",
        user: "Utilisateur",
        organization: "Organisation",
        status: "Statut",
        created: "Créé",
        actions: "Actions",
        createNewUser: "Créer Nouvel Utilisateur",
        addNewUserDesc: "Ajouter un nouvel utilisateur au système avec un rôle et des permissions spécifiques",
        editUser: "Modifier Utilisateur",
        updateUserDesc: "Mettre à jour les informations et permissions de l'utilisateur",
        fullName: "Nom Complet",
        email: "Email",
        password: "Mot de passe",
        role: "Rôle",
        phone: "Téléphone",
        phoneOptional: "Téléphone (Optionnel)",
        organizationOptional: "Organisation (Optionnel)",
        isActive: "Actif",
        saveChanges: "Enregistrer les Modifications",
        deactivateConfirm: "Êtes-vous sûr de vouloir désactiver cet utilisateur?",
        noUsersFound: "Aucun utilisateur trouvé",
        loadingUsers: "Chargement des utilisateurs...",
        page: "Page",
        of: "de",
        previous: "Précédent",
        next: "Suivant"
      },
      
      // Roles & Permissions
      roles: {
        owner: "Propriétaire",
        client: "Client",
        admin: "Administrateur",
        observer: "Observateur",
        reporter: "Reporter",
        super_admin: "Super Administrateur",
        election_manager: "Gestionnaire Electoral",
        media: "Média",
        viewer: "Visiteur"
      },
      
      roleDescriptions: {
        super_admin: "Accès complet au système, peut intégrer et gérer tous les utilisateurs",
        election_manager: "Officiels ELECAM - gérer les élections et approuver les résultats",
        media: "Maisons de médias - voir et rapporter les résultats des élections",
        observer: "Observateurs indépendants - voir les résultats et signaler les problèmes",
        reporter: "Reporters de terrain - soumettre les résultats",
        viewer: "Visiteurs publics - accès en lecture seule"
      },
      
      // Interactive Map
      interactiveMap: {
        title: "Carte Interactive",
        subtitle: "Explorer les données électorales par région",
        national: "National",
        nationalView: "Vue Nationale",
        divisionsView: "Vue Départements",
        councilsView: "Vue Communes",
        villagesView: "Vue Villages",
        backToNational: "Retour à la Vue Nationale",
        backToDivisions: "Retour aux Départements",
        backToCouncils: "Retour aux Communes",
        clickToDrillDown: "Cliquez pour explorer",
        clickToViewCouncils: "Cliquez pour voir les communes",
        clickToViewVillages: "Cliquer pour voir les villages",
        coverageLegend: "Légende de Couverture",
        reported80Plus: "80%+ rapporté",
        reported50to80: "50-80% rapporté",
        reported20to50: "20-50% rapporté",
        reportedLess20: "<20% rapporté",
        divisions: "Départements",
        councils: "Communes",
        villages: "Villages",
        totalDivisions: "Total Départements",
        totalCouncils: "Total Communes",
        totalVillages: "Total Villages",
        villageView: "Vue Villages",
        councilView: "Vue Communes",
        divisionView: "Vue Départements",
        municipalityView: "Vue Municipalités",
        division: "Département",
        council: "Commune",
        region: "Région",
        municipality: "Municipalité",
        availableFromOSM: "Depuis les données OpenStreetMap",
        detailedBoundaries: "Frontières détaillées",
        villageBoundaries: "Frontières des villages",
        coverage: "Couverture",
        complete: "complet",
        reported: "rapporté",
        total: "total",
        leadingCandidate: "Candidat en Tête",
        leadingParty: "Parti en Tête",
        noDataYet: "Aucune donnée encore",
        resultsWillAppear: "Les résultats apparaîtront une fois les soumissions approuvées"
      },
      
      // Elections
      elections: {
        title: "Élections",
        subtitle: "Gérer tous les types d'élections",
        allTypes: "Tous Types",
        presidential: "Présidentielle",
        parliamentary: "Législatives",
        regional: "Régionales",
        council: "Municipales",
        senatorial: "Sénatoriales",
        manage: "Gérer",
        viewResults: "Voir Résultats",
        submitResults: "Soumettre Résultats",
        description: {
          presidential: "Élire le Président de la République",
          parliamentary: "Élire les députés à l'Assemblée Nationale",
          regional: "Élire les conseillers régionaux",
          council: "Élire les conseillers municipaux",
          senatorial: "Élire les sénateurs"
        }
      },
      
      // Verification Portal
      verification: {
        title: "Portail de Vérification",
        subtitle: "Réviser et approuver les résultats soumis",
        pending: "En Attente",
        underReview: "En Révision",
        correctionRequested: "Correction Demandée",
        filterByElection: "Filtrer par élection",
        filterByRegion: "Filtrer par région",
        filterByStatus: "Filtrer par statut",
        allElections: "Toutes les élections",
        allRegions: "Toutes les régions",
        allStatuses: "Tous les statuts",
        submittedBy: "Soumis par",
        submittedAt: "Soumis le",
        pollingStation: "Bureau de Vote",
        electionType: "Type d'Élection",
        region: "Région",
        actions: "Actions",
        review: "Réviser",
        approve: "Approuver",
        reject: "Rejeter",
        requestCorrection: "Demander Correction",
        reviewResult: "Réviser Résultat",
        resultDetails: "Détails du Résultat",
        registeredVoters: "Électeurs Inscrits",
        votesCast: "Votes Exprimés",
        validVotes: "Votes Valides",
        invalidVotes: "Votes Invalides",
        candidateVotes: "Votes par Candidat",
        resultSheets: "Feuilles de Résultats",
        noPhotos: "Aucune photo disponible",
        approvalActions: "Actions d'Approbation",
        approveResult: "Approuver Résultat",
        rejectResult: "Rejeter Résultat",
        requestCorrectionResult: "Demander Correction",
        confirmApprove: "Confirmer l'approbation",
        confirmReject: "Confirmer le rejet",
        reasonForRejection: "Raison du rejet",
        reasonForCorrection: "Raison de la correction demandée",
        cancel: "Annuler",
        confirm: "Confirmer",
        noResultsPending: "Aucun résultat en attente de vérification"
      },
      
      // Election Night Dashboard
      electionNight: {
        title: "Tableau de Bord Soirée Électorale",
        subtitle: "Résultats en temps réel pour tous les types d'élections",
        live: "EN DIRECT",
        selectElection: "Sélectionner Type d'Élection",
        nationalResults: "Résultats Nationaux",
        leadingCandidates: "Candidats en Tête",
        topParties: "Principaux Partis",
        regionalBreakdown: "Répartition Régionale",
        turnoutRate: "Taux de Participation",
        resultsProgress: "Progression des Résultats",
        divisionsCovered: "Départements Couverts",
        constituenciesCovered: "Circonscriptions Couvertes",
        councilsCovered: "Communes Couvertes",
        seatsCovered: "Sièges Couverts",
        votes: "votes",
        seats: "sièges",
        councils: "communes",
        projectedWinner: "Vainqueur Projeté",
        tooEarlyToProject: "Trop tôt pour projeter",
        keyStats: "Statistiques Clés",
        totalRegistered: "Total Inscrits",
        totalVotesCast: "Total Votes Exprimés",
        validVotes: "Votes Valides",
        invalidVotes: "Votes Invalides"
      },
      
      // Buttons & Actions
      buttons: {
        save: "Enregistrer",
        cancel: "Annuler",
        delete: "Supprimer",
        edit: "Modifier",
        view: "Voir",
        create: "Créer",
        update: "Mettre à jour",
        submit: "Soumettre",
        approve: "Approuver",
        reject: "Rejeter",
        verify: "Vérifier",
        download: "Télécharger",
        upload: "Téléverser",
        export: "Exporter",
        import: "Importer",
        search: "Rechercher",
        filter: "Filtrer",
        reset: "Réinitialiser",
        refresh: "Actualiser",
        close: "Fermer",
        back: "Retour",
        next: "Suivant",
        previous: "Précédent",
        confirm: "Confirmer",
        yes: "Oui",
        no: "Non"
      },
      
      // Messages
      messages: {
        loading: "Chargement...",
        saving: "Enregistrement...",
        saved: "Enregistré avec succès",
        error: "Une erreur est survenue",
        success: "Opération réussie",
        noData: "Aucune donnée disponible",
        noResults: "Aucun résultat trouvé",
        confirmDelete: "Êtes-vous sûr de vouloir supprimer?",
        confirmAction: "Êtes-vous sûr de vouloir continuer?",
        unauthorized: "Non autorisé",
        permissionDenied: "Permission refusée",
        sessionExpired: "Session expirée. Veuillez vous reconnecter.",
        networkError: "Erreur de réseau. Vérifiez votre connexion.",
        invalidInput: "Entrée invalide",
        required: "Ce champ est requis",
        uploadSuccess: "Téléversement réussi",
        uploadFailed: "Échec du téléversement",
        deleteSuccess: "Suppression réussie",
        deleteFailed: "Échec de la suppression",
        updateSuccess: "Mise à jour réussie",
        updateFailed: "Échec de la mise à jour",
        createSuccess: "Création réussie",
        createFailed: "Échec de la création"
      }
    }
  }
};

// Per-page translations: every file in ./locales exports { en: {...}, fr: {...} }
// and is merged into the root `translation` namespace.
const localeFiles = require.context('./locales', false, /\.js$/);
localeFiles.keys().forEach((key) => {
  const mod = localeFiles(key).default || {};
  Object.keys(mod).forEach((lang) => {
    if (translations[lang]) {
      Object.assign(translations[lang].translation, mod[lang]);
    }
  });
});

export default translations;
